import { useGetProductImagesURLQuery } from "../app/api-slice";
import { MenuFamily } from '../app/types/catalog-types'
import { useDataRequestLang } from '../app/main-slice';

export const useImageURLToFamily = (families: MenuFamily[]) => {

    const lang = useDataRequestLang();

    const { data: familiesInfo = [], isSuccess: isImageSuccess } = useGetProductImagesURLQuery({lang});
    
    const familiesWihtImg = families.map(family => {
        let imageUrl = familiesInfo?.find((familyInfo: Record<string, string>) => familyInfo.ProductCode == family.code);

        return {
            ...family,
            image: imageUrl && imageUrl.refimage.replace(/\\/g, '')
        };
    });

    return familiesWihtImg;
}